export default {
  install: function(Vue, options) {
    const component = {
      name: 'Snackbar',
      model: {
        prop: 'text',
        event: 'change'
      },
      props: ['text'],
      data: () => ({
        visible: false,
        timeoutHandler: null
      }),
      watch: {
        text(val) {
          if (val) {
            this.visible = true;
            if (this.timeoutHandler) clearTimeout(this.timeoutHandler);
            this.timeoutHandler = setTimeout(() => {
              this.$emit('change', null);
              this.visible = false;
            }, 3000);
          }
        }
      },
      template: `<v-snackbar :timeout="0" :top="true" :right="true" v-model="visible">{{ text }}</v-snackbar>`
    };
    Vue.component('toast', component);
  }
};



// WEBPACK FOOTER //
// ./src/components/utils/Toast.js